import React from 'react';
import { Button, Input, ModalBox, useCopyToClipboard, useModalContext, } from '@fourthwall/components';
import { DuplicateIcon } from '@fourthwall/icons';
import * as S from './CheckoutUrlSetupModal.styled';
export const CheckoutUrlSetupModal = ({ metaCommerceCheckoutSetupUri, fwCheckoutRedirectUri, }) => {
    const { close } = useModalContext();
    const { copyToClipboard } = useCopyToClipboard();
    return (React.createElement(ModalBox, { title: "Set up your Meta checkout URL", size: "large", onClose: close },
        React.createElement(S.ContentContainer, null,
            React.createElement(S.Description, null, "This URL allows Meta to direct customers to Fourthwall checkout when they purchase from your Instagram or Facebook shop."),
            React.createElement(S.StepsList, null,
                React.createElement(S.StepItem, null,
                    React.createElement(S.StepNumber, null, "1."),
                    React.createElement(S.StepContent, null, "Enter Meta setup process by clicking on button below:")),
                React.createElement(S.ButtonContainer, null,
                    React.createElement(Button, { appearance: "primary", label: "Set up your checkout URL", href: metaCommerceCheckoutSetupUri, target: "_blank" })),
                React.createElement(S.StepItem, null,
                    React.createElement(S.StepNumber, null, "2."),
                    React.createElement(S.StepContent, null, "Copy checkout URL domain and paste it in the Meta setup:")),
                React.createElement(S.UrlInputContainer, null,
                    React.createElement(S.InputWrapper, null,
                        React.createElement(Input, { readOnly: true, value: fwCheckoutRedirectUri, fullWidth: true })),
                    React.createElement(Button, { appearance: "secondary", label: "Copy URL", leftIcon: React.createElement(DuplicateIcon, null), onClick: () => copyToClipboard(fwCheckoutRedirectUri) })),
                React.createElement(S.StepItem, null,
                    React.createElement(S.StepNumber, null, "3."),
                    React.createElement(S.StepContent, null, "Finish your setup on Meta and save your settings.")),
                React.createElement(S.StepItem, null,
                    React.createElement(S.StepNumber, null, "4."),
                    React.createElement(S.StepContent, null, "Your Meta shop should be working now!"))))));
};
